module.exports = __webpack_public_path__ + "static/b3-832c3fb9b254d6bf00dd2d9e428dc8b4.jpg";